<div class="interaction-dialog">
    <div class="popup-msg-content" ng-class="{alert:options.alert}">
        <h1>{{$ctrl.header|translate:language}}</h1>
        <c-auto-form config="$ctrl.autoFormConfig" class="autoform-no-margins"></c-auto-form>
    </div>
    <div class="popup-button-content">
        <span ng-if="!$ctrl.isValid" class="error-text">{{'interaction.notValid'|translate:language}}</span>
        <span><button class="popup-msg-button btn-primary" ng-click="$ctrl.ok()" ng-class="{alert:options.alert}"><span>{{$ctrl.buttonSend}}</span></button></span>
        <span><button id="cancel" class="popup-msg-button" ng-click="$ctrl.cancel()"><span>{{$ctrl.buttonCancel}}</span></button></span>
    </div>
</div>